export class QueryResults<T = unknown> {
  constructor(
    public results: T[],
    public total: number,
    public additionalInfo?: { [key: string]: string }
  ) {}
}
